import request from '@/utils/request'

// 获取教师列表
export function getTeachers() {
  return request({
    url: '/teachers',
    method: 'get'
  })
}

// 创建教师
export function createTeacher(data) {
  return request({
    url: '/teachers',
    method: 'post',
    data: {
      username: data.username,
      password: data.password,
      role: data.role || 'teacher',
      name: data.name,
      phone: data.phone,
      subjects: data.subjects || [],
      education: data.education,
      title: data.title,
      introduction: data.introduction,
      campuses: data.campuses || [],
      permission_group: data.permission_group
    }
  })
}

// 将现有用户设置为教师
export function createTeacherWithUser(data) {
  return request({
    url: '/teachers/with-user',
    method: 'post',
    data: {
      user: data.userId,
      subjects: data.subjects || [],
      campuses: data.campuses || [],
      introduction: data.introduction || ''
    }
  })
}

// 取消用户的教师身份
export function removeTeacherByUser(userId) {
  return request({
    url: `/teachers/user/${userId}`,
    method: 'delete'
  })
}

// 更新教师信息
export function updateTeacher(id, data) {
  return request({
    url: `/teachers/${id}`,
    method: 'patch',
    data: {
      name: data.name,
      phone: data.phone,
      subjects: data.subjects,
      introduction: data.introduction,
      campuses: data.campuses
    }
  })
}

// 删除教师
export function deleteTeacher(id) {
  return request({
    url: `/teachers/${id}`,
    method: 'delete'
  })
} 